export enum RewardsBalancePaymentMethods {
  'bank-transfer',
  'credit-line',
  'balance'
}

export enum RewardsOrderTypesEnum {
  'outgoings',
  'deposits'
}

export type RewardsOrderTypes = 'outgoings' | 'deposits';

export type RewardsOrderStatus = 'sent' | 'failed' | 'approved' | 'rejected' | 'inProgress';

export type RewardsOrderDetailStatus = 'assigned' | 'pending' | 'voided';
